module.exports = __webpack_public_path__ + "static/media/protect_devices.d87f5798.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab-images/protect_devices.jpg
// module id = 208
// module chunks = 0